import { type ComponentProps } from 'react';

export default function LaunchVehicleIcon ({ ...otherProps }: ComponentProps<'svg'>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 432 512' fill='currentColor' {...otherProps}>
      <path d='m129.8 517H0V360.2c0-6.6 1.6-13.1 4.5-18.9L37.8 269c12.8-19.4 41.1-19.4 53.9 0l33.3 72.3c3 5.9 4.5 12.3 4.5 18.9V517zm300.5 0H300.5V360.2c0-6.6 1.6-13.1 4.5-18.9l33.3-72.3c12.8-19.4 41.1-19.4 53.9 0l33.3 72.3c3 5.9 4.5 12.3 4.5 18.9V517zM279.8 105.8c0-6.6-1.6-13.1-4.5-18.9L242.1 14.6c-12.8-19.4-41.1-19.4-53.9 0l-33.3 72.3c-3 5.9-4.5 12.3-4.5 18.9v411.4h129.8V105.8z' />
    </svg>
  );
}
